import React, { useState, useEffect } from "react";

import { API_URL, createMarkup } from "../helpers";

import Hdg from "../components/Hdg";
//import NotifyForm from "../components/NotifyForm";
import Nav from "../components/Nav";
import Alert from "../components/Alert";

import LeaderboardNew from "./LeaderboardNew";
import Instagram from "./Instagram";

const Overview = () => {
	const [html, setHtml] = useState({});
	const [leaderboard, setLeaderboard] = useState({
		top10: [],
		total: "",
		goal: "",
		percent: 0,
		lastupdated: "",
	});
	const [leaderboardNew, setLeaderboardNew] = useState({
		peers: [],
		total: "",
		lastupdated: "",
	});
	const [imgs, setImgs] = useState([]);
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/overviewInit`);
		const params = {
			left: `overview`,
			right: `right-featured-birdies`,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setLeaderboard({ ...json.leaderboard });
				setLeaderboardNew({ ...json.leaderboardNew });
				setImgs(json.imgs);
				setHtml({
					left: json.left,
					right: json.right,
				});
				setAlert({});
				window.jQuery(".cycle-slideshow").cycle("stop");
				window.jQuery(".cycle-slideshow").cycle();
			} else {
				setAlert({
					type: json.resp === 2 ? "notice" : "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg />
						{/*<NotifyForm />*/}
						{/*<div className="blocktext">
        <h3
          style={{
            color: "#e2231a",
            borderBottom: "none",
            paddingBottom: "0px",
          }}
        >
          Birdies 101 – January 24 Event
        </h3>
        <p style={{ color: "#e2231a" }}>
          We are hosting a breakfast and lunch session – both on Wednesday,
          January 24 - to learn more about the Birdies for Charity program.
          <br />
          Please click below to RSVP for either session.
        </p>
        <div className="spacer"></div>
        <div className="redbutton valerolink">
          <a href="/birdies101/">
            <i className="fa fa-file-text-o"></i>Birdies 101
            <i className="fa fa-angle-right"></i>
          </a>
        </div>
      </div>
      <div className="spacer"></div>*/}
						<div className="spacer"></div>
						<Nav />
						<div dangerouslySetInnerHTML={createMarkup(html.left)} />
						{/*leaderboard.top10.length > 0 && <Leaderboard data={leaderboard} />*/}
						{leaderboardNew.peers.length > 0 && (
							<LeaderboardNew data={leaderboardNew} />
						)}
						<div className="spacer"></div>
						<Instagram data={imgs} />
					</div>

					<div
						id="right-column"
						dangerouslySetInnerHTML={createMarkup(html.right)}
					/>
				</>
			)}
		</>
	);
};

export default Overview;
